import { render, staticRenderFns } from "./SingleGallery.vue?vue&type=template&id=ff79d6c8"
import script from "./SingleGallery.vue?vue&type=script&lang=js"
export * from "./SingleGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports